import React from 'react'

import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import LazyImgwrapper from '@nexys/components/LazyImgWrapper'
import { Button, Col, Row } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { Title } from 'shortcuts/Typography'

import useGetAllGallery from 'data/useGetAllGallery'

import classNames from 'views/Home/partials/HighlightPost.module.scss'

import 'flickity/css/flickity.css'
const FlickityNoServerside: any = dynamic(
  () => import('react-flickity-component'),
  {
    ssr: false,
  },
)

const Galery = (): JSX.Element => {
  const { xs, sm, md, lg, xl, xxl } = useBreakpoint()
  const { data: dataset } = useGetAllGallery(1, 100, null, 'getAll')
  const router = useRouter()

  const mapDataset = dataset
    ?.map((gallery) => ({
      ...gallery,
      file: {
        media_url: gallery.path ? `${gallery.path.replace('public', '')} ` : '',
        media_type: gallery.type.toUpperCase(),
      },
    }))
    .filter((data) => data.type !== 'slider')

  const filteredSlider = dataset
    ?.map((gallery) => ({
      ...gallery,
      file: {
        media_url: gallery.path ? `${gallery.path.replace('public', '')} ` : '',
        media_type: gallery.type.toUpperCase(),
      },
    }))
    .filter((data) => data.type === 'slider')

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          // marginTop: xs ? '70px' : '100px',
          marginBottom: '20px',
          width: '100%',
        }}
      >
        <Title
          style={{
            fontSize: xs ? '20px' : '36px',
            color: '#2C2C2C',
            fontFamily: 'Inter-Bold',
            fontWeight: '700',
          }}
        >
          Galery
        </Title>
        <Button
          style={{ color: '#985ECF' }}
          className={`${classNames.buttonDefault} max-sm:hidden`}
          onClick={() => {
            router.push('/gallery')
          }}
        >
          Lihat Semua
        </Button>
      </div>

      <Row justify="space-between" align="middle" gutter={[20, 20]}>
        <Col xs={24} lg={12} md={12} xl={12} sm={24} xxl={12}>
          <FlickityNoServerside
            options={{
              initialIndex: 0,
              autoPlay: 2000,
              pageDots: false,
              prevNextButtons: false,
              wrapAround: true,
              imagesLoaded: true,
              draggable: true,
            }}
            reloadOnUpdate
          >
            {filteredSlider?.map((data) => (
              <div className={`w-full ${xs ? 'h-[192px]' : 'h-[404px]'} mx-2`}>
                <img
                  src={data.file.media_url}
                  alt="test"
                  className={`object-cover rounded-xl w-full h-full`}
                />
              </div>
            ))}
          </FlickityNoServerside>
        </Col>
        <Col sm={24} lg={12} md={12} xl={12} xxl={12}>
          <Row gutter={[20, 20]} className='max-sm:hidden flex'>
            {mapDataset?.slice(0, 4)?.map((d) => (
              <Col xs={24} lg={12} md={12} xl={12} sm={12} xxl={12}>
                {d?.file?.media_type === 'IMAGE' ? (
                  <div
                    className={`w-full h-[192px] mx-auto ${classNames.frameIg}`}
                  >
                    <LazyImgwrapper className={'w-full h-full'}>
                      <img
                        className={'w-full h-full object-cover rounded-xl'}
                        src={d.file.media_url}
                        alt={d.file.media_url}
                      />
                    </LazyImgwrapper>
                  </div>
                ) : (
                  <div
                    className={`relative w-full h-[192px] mx-auto ${classNames.frameIg}`}
                  >
                    {d?.file?.media_url && (
                      <video
                        controls
                        autoPlay={false}
                        id="iframe"
                        className={'w-full h-full object-cover rounded-xl'}
                        src={d?.file?.media_url}
                      ></video>
                    )}
                  </div>
                )}
              </Col>
            ))}
          </Row>
        </Col>
        <div className="w-full text-center">
          <Button
            style={{ color: '#985ECF' }}
            className={`${classNames.buttonDefault} max-sm:inline-block hidden`}
            onClick={() => {
              router.push('/gallery')
            }}
          >
            Lihat Semua
          </Button>
        </div>
      </Row>
    </>
  )
}

export default Galery
